// src/componentes/accesos/EnlaceRecepcion.js
// /asistencia/{gym}#{clave}: lo abre la cámara del celular al escanear el QR impreso de
// recepción. Guarda el código y lleva al portal; allí (tras iniciar sesión si hace falta)
// el socio ve su clase y confirma su asistencia.
import { useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { codigoRecepcion, guardarRecepcionPendiente } from '../../dominio/qrRecepcion';

export const EnlaceRecepcion = () => {
  const { gymId } = useParams();
  const codigo = codigoRecepcion(`/asistencia/${gymId}${window.location.hash}`);
  // Se guarda antes de redirigir (una sola vez por apertura).
  useState(() => { if (codigo) guardarRecepcionPendiente(codigo); return true; });
  return <Navigate to="/" replace />;
};

export default EnlaceRecepcion;
